import React from "react";

const BARS = [36, 52, 42, 66, 56, 80, 71, 84, 75, 89, 82, 86];

export default function ChartMock() {
  const width = 620;
  const height = 144;
  const gap = 6;
  const padX = 16;
  const padY = 16;
  const barW = (width - padX * 2 - gap * (BARS.length - 1)) / BARS.length;
  const maxBar = Math.max(...BARS);

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className="h-full w-full"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="barGradient" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#31D084" />
          <stop offset="100%" stopColor="#12915C" />
        </linearGradient>
      </defs>
      {BARS.map((bar, i) => {
        const h = ((height - padY * 2) * bar) / maxBar;
        const x = padX + i * (barW + gap);
        const y = height - padY - h;

        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={barW}
            height={h}
            rx="4"
            fill="url(#barGradient)"
          />
        );
      })}
    </svg>
  );
}
